import { useMemo } from 'react'
import { generatePath } from 'react-router-dom'
import { AUTOPILOT_INTEGRATIONS_PATH } from 'paths'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { Lightning, LightningFilled } from 'blaze-ui/icons'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { useCurrentBrandPlan } from 'hooks/queries/brandPlans/useCurrentBrandPlan'
import { useExternalIntegrations } from 'components/ExportModal/ExternalIntegrations/ExternalIntegrations'
import { useIntegrationTactics } from 'screens/Integrations/useIntegrationTactics'
import { getProviderCounts } from 'screens/Integrations/utils'
import Styles from './NavMenuAutopilotIntegrationsItem.module.scss'

interface Props {
  onPress: () => void
}

const NavMenuAutopilotIntegrationsItem = ({ onPress }: Props) => {
  const workspaceId = useCurrentWorkspaceId()
  const isActivationBannerEnabled = useFlipperFlag('home_v4')
  const { data: brandPlan } = useCurrentBrandPlan()
  const { data: integrations } = useExternalIntegrations({ enabled: isActivationBannerEnabled })
  const tactics = useIntegrationTactics({ enabled: isActivationBannerEnabled })

  const { connectedProviders, totalPossibleProviders } = useMemo(
    () =>
      getProviderCounts(
        integrations?.external_integrations,
        tactics,
        brandPlan?.selected_blog_platform,
        brandPlan?.selected_email_platform,
      ),
    [
      integrations?.external_integrations,
      tactics,
      brandPlan?.selected_blog_platform,
      brandPlan?.selected_email_platform,
    ],
  )

  const connected = connectedProviders.length
  const total = totalPossibleProviders.length

  return (
    <NavMenuItem
      icon={Lightning}
      activeIcon={LightningFilled}
      to={generatePath(AUTOPILOT_INTEGRATIONS_PATH, { workspaceId })}
      onPress={onPress}
      label="Integrations"
    >
      {isActivationBannerEnabled && total > 0 && (
        <span className={Styles.counter}>
          {connected}/{total}
        </span>
      )}
    </NavMenuItem>
  )
}

export { NavMenuAutopilotIntegrationsItem }
